import type { ReactNode } from "react";
import { Navigate } from "react-router-dom";
import { Spinner } from "@/components/ui/spinner";
import { useAuthStore } from "@/stores/useAuthStore";
import { hasPermission, type Permission } from "@/lib/permissions";
import { ROUTES } from "@/lib/routes";

type PermissionRouteProps = {
  permission: Permission;
  children: ReactNode;
  redirectTo?: string;
};

export default function PermissionRoute({
  permission,
  children,
  redirectTo = ROUTES.HOME,
}: PermissionRouteProps) {
  const roles = useAuthStore((s) => s.roles);
  const isRolesLoaded = useAuthStore((s) => s.isRolesLoaded);

  if (!isRolesLoaded) {
    return (
      <div className="flex w-full min-h-[40vh] items-center justify-center">
        <Spinner className="size-6" />
      </div>
    );
  }

  if (!hasPermission(roles, permission)) {
    return <Navigate to={redirectTo} replace />;
  }

  return <>{children}</>;
}
